// extracted by mini-css-extract-plugin
export default {"base":"Cell_base__bFVcS","content":"Cell_content__q1paC","isId":"Cell_isId__B-Gqi"};